import React, { Component } from 'react';
import SettingsMenu from './SettingsMenu.js';
import GameButton from './GameButton.js';

class Board extends React.Component {
  constructor(){
    super();
    this.state = {
      illuminateGreen:false,
      illumintaeRed:false,
      illuminateYellow:false,
      illuminateBlue:false,
      gameActive:false,
      gameStarted:false,
      strictMode:false,
      round: 0,
      error: false,
      gameOver: false,
    };
    this.sequenceInterval;
    this.clickable = false;
    this.sequence = [];
    this.guess = [];
    this.toggleGame = this.toggleGame.bind(this);
    this.restartGame = this.restartGame.bind(this);
    this.toggleStrict = this.toggleStrict.bind(this);
    this.restartGame = this.restartGame.bind(this);
    this.pressButton = this.pressButton.bind(this);
  }

  pressButton(btnNum){
    if (this.clickable && this.state.gameActive){

      // perform button animation
      this.clickable = false;
      this.playButton(btnNum);
      this.clickable = true;

      // check if input correct
      this.guess.push(btnNum);
      console.log("Sequence:",this.sequence);
      console.log("Button:",btnNum);
      console.log("Guess:",this.guess);
      if (this.guess[this.guess.length-1] !== this.sequence[this.guess.length-1]){
        this.guess = [];
        // display error
        this.setState({error:true}, function() {
          window.setTimeout(() => {
          this.setState({error:false},function() {
            // or if strict mode -> perform restart
            if (this.state.strictMode){
              this.restartGame();
            } else{
              this.playSequence();
            }
          });
          },1000);
        });


      }
      // if user guessed sequence correctly -> move on to next round
      if (this.guess.length == this.sequence.length){

        // check game over condition
        if (this.guess.length == 15){
          this.clickable = false;
          this.setState({gameOver: true});
        } else{
          this.nextRound();
        }
      this.guess = [];

      }

    }
  }

  playButton(btnNum){
    var dict = ["illuminateGreen","illuminateRed","illuminateYellow","illuminateBlue"];

    if (this.state.gameActive){

      // pass the second state update in a callback function to ensure delayed execution
      this.setState({[dict[btnNum]]: true}, function() {
        // play corresponding audio file
        document.getElementById('audio-'+btnNum).play();
        // arrow function to prevent binding of this to window
        window.setTimeout(() => {
          this.setState({[dict[btnNum]]: false});
        },500);
      });
    }
  }

  restartGame(){

  if (this.state.gameActive){

    if (this.state.gameStarted){
      this.setState({gameStarted:false});
      window.clearInterval(this.sequenceInterval);
      if (this.state.gameOver){
        this.setState({gameOver:false});
      }
        this.setState({round: 0,error:false}, function() {
          this.sequence = [];
          this.guess = [];
        });

    }else{
      this.setState({gameStarted:true}, function() {
        this.nextRound();
      });
    }
  }


  }

  toggleGame(){

    var newState = (this.state.gameActive) ? false : true;
    this.setState({gameActive: newState}, () => {
      if (!this.state.gameActive){
        window.clearInterval(this.sequenceInterval);
        this.guess = [];
        this.sequence = [];
        this.setState({strictMode:false,round: 0,error: false});
      }
    });

  }

    toggleStrict(){
      if (this.state.gameActive && !this.state.gameStarted){
    var newState = (this.state.strictMode) ? false : true;
    this.setState({strictMode: newState});
      }
  }

  toggleButtonAccess(){
    this.clickable = (this.clickable) ? false : true;
  }

  nextRound(){
    // increment round
    var round = this.state.round;
    this.setState({round:round+1});
    this.generateNewItem();
    this.playSequence();
  }



  playSequence(){
    this.clickable = false;
    var sequence = this.sequence;
    var counter = 0;
    this.sequenceInterval =  window.setInterval(() => {
       var value = sequence[counter];
       this.playButton(value);
       counter++;
       if (counter == (sequence.length)){
         clearInterval(this.sequenceInterval);
         this.clickable= true;
       }
      },1000);


  }

  generateNewItem(){
    // generate random number between 0 and 3
    var newElem = Math.floor(Math.random() * 3) + 0;
    this.sequence.push(newElem);
  }



  render() {
    return (
      <div className ="game-container">
       <SettingsMenu toggleGame={this.toggleGame} gameActive={this.state.gameActive} strictMode={this.state.strictMode} toggleStrict={this.toggleStrict} restartGame={this.restartGame} gameActive={this.state.gameActive} round={this.state.round} restart={this.restartGame.bind(this)} error={this.state.error} gameOver={this.state.gameOver} gameStarted={this.state.gameStarted}/>
       <GameButton colorClass="game-btn green" color="green" illuminated={this.state.illuminateGreen} playButton = {() => this.pressButton(0)}/>
        <GameButton colorClass="game-btn red" color="red" illuminated={this.state.illuminateRed} playButton = {() => this.pressButton(1)}/>
       <GameButton colorClass="game-btn yellow" color="yellow" illuminated={this.state.illuminateYellow} playButton = {() => this.pressButton(2)}/>
       <GameButton colorClass="game-btn blue" color="blue" illuminated={this.state.illuminateBlue} playButton = {() => this.pressButton(3)}/>

      </div>

    );
  }
}

export default Board;


// WEBPACK FOOTER //
// ./src/Board.js